import { IconProps } from '@app/components/Atoms/Icon'
import React from 'react'

export const PrioritisationIcon: React.FC<IconProps> = ({
  active,
  onClick,
  className,
  ...rest
}) => {
  return (
    <svg
      {...rest}
      className={className}
      onClick={onClick}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1868 10.249H13.7119V22.6256H17.1868V10.249Z"
        fill={active ? '#0B2948' : '#FBFBFB'}
      />
      <path
        d="M10.5 21.1782L15.4494 29.7506L20.4019 21.1782H10.5Z"
        fill={active ? '#0B2948' : '#FBFBFB'}
      />
      <path d="M26.2879 17.374H22.813V29.7506H26.2879V17.374Z" fill="#61C9DC" />
      <path d="M29.5 18.8214L24.5505 10.249L19.6011 18.8214H29.5Z" fill="#61C9DC" />
    </svg>
  )
}

export default PrioritisationIcon
